import { URLS } from "@/constants/urls";
import { ContactFormData } from "@/types/forms";
import { postFormData } from "./post-form-data/post-form-data";

type Response = {
    message: string
}

export const postContactUsForm = postFormData<ContactFormData, Response>(URLS.ContactUsForm)